import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { SelectCategory } from './SelectCategory.js';
import { SelectProvider } from './SelectContext.js';
import { SelectDropdown } from './SelectDropdown.js';
import { SelectInput } from './SelectInput.js';
import { SelectMobile } from './SelectMobile.js';
import { SelectOption } from './SelectOption.js';
import { Wrapper } from './styles.js';
import 'styled-components';
import '../../utils/opacityDisabled.js';
import { isMobileDevice } from '../../utils/isMobileDevice.js';

function Select(_a) {
    var { label, id, multi, children, helperText, feedback, disabled, readOnly, onSelect, isLoading, appendSelectDropdownTo, prefix, onClick, onFocus, onBlur, onChange, minSearchChars = 0, suffix } = _a, props = __rest(_a, ["label", "id", "multi", "children", "helperText", "feedback", "disabled", "readOnly", "onSelect", "isLoading", "appendSelectDropdownTo", "prefix", "onClick", "onFocus", "onBlur", "onChange", "minSearchChars", "suffix"]);
    const [mounted, setMounted] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [inputWidth, setInputWidth] = useState(0);
    const [shouldRenderDropdown, setShouldRenderDropdown] = useState(false);
    const handleFocus = () => {
        if (readOnly) {
            return;
        }
        setIsInputFocused(true);
        setShouldRenderDropdown(true);
    };
    const handleInputFocus = (event) => {
        handleFocus();
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    };
    const handleInputClick = (event) => {
        handleFocus();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    const handleInputChange = (event) => {
        handleFocus();
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const handleInputBlur = (event) => {
        setIsInputFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    const inputWrapperRef = useRef(null);
    useEffect(() => {
        if (inputWrapperRef.current && shouldRenderDropdown) {
            setInputWidth(inputWrapperRef.current.offsetWidth);
        }
    }, [shouldRenderDropdown, inputWrapperRef.current]);
    useEffect(() => {
        setMounted(true);
    }, []);
    useEffect(() => {
        setIsMobile(isMobileDevice());
    }, []);
    const handleOptionsClose = useCallback(() => {
        setIsInputFocused(false);
        setShouldRenderDropdown(false);
    }, []);
    if (!mounted) {
        return null;
    }
    if (isMobile) {
        return (React.createElement(SelectProvider, { multi: multi, onSelect: onSelect, onClose: handleOptionsClose, isMobile: isMobile, minSearchChars: minSearchChars },
            React.createElement(SelectMobile, { label: label, id: id, multi: multi, helperText: helperText, feedback: feedback, disabled: disabled, readOnly: readOnly, placeholder: props.placeholder || '', required: !!props.required, suffix: suffix }, children)));
    }
    return (React.createElement(SelectProvider, { multi: multi, onSelect: onSelect, onClose: handleOptionsClose, minSearchChars: minSearchChars },
        React.createElement(Wrapper, { ref: inputWrapperRef },
            React.createElement(SelectInput, Object.assign({ label: label, id: id }, props, { role: "combobox", onClick: handleInputClick, onChange: handleInputChange, onFocus: handleInputFocus, handleFocus: handleFocus, onBlur: handleInputBlur, isInputFocused: isInputFocused, helperText: helperText, feedback: feedback, disabled: disabled, readOnly: readOnly, prefix: prefix, suffix: suffix })),
            React.createElement(SelectDropdown, { isOpen: shouldRenderDropdown, anchorElement: inputWrapperRef, onClose: handleOptionsClose, minWidth: `${inputWidth}px`, isLoading: isLoading, appendTo: appendSelectDropdownTo, focusTrapContainerElements: [
                    inputWrapperRef.current,
                ] }, children))));
}
const SelectNamespace = Object.assign(Select, {
    Option: SelectOption,
    Category: SelectCategory,
});

export { Select, SelectNamespace };
